import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Fotter from "./Fotter";
import { Link } from "react-router-dom";
import SettingSidebar from "./SettingSidebar";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../Pages/Config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { formatDate } from "../components/dateUtils";

export default function Settinglost() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const login_user_id = Cookies.get("user_id");
  const [BidCount, setBidCount] = useState({});
  const [relistuser, setrelistuser] = useState([]);

  const fetchBidCounts = async (productIds) => {
    console.log("ids", productIds);
    try {
      const response = await axios.post(`${BASE_URL}/bid_count.php`, {
        ids: productIds,
      });

      if (response.data.success) {
        setBidCount(response.data.data);
      } else {
        console.error("Bid count fetch failed");
      }
    } catch (error) {
      console.error("Error fetching bid counts:", error);
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      const userId = Cookies.get("user_id");

      if (!userId) return;
      try {
        const response = await axios.get(
          `${BASE_URL}/all_user_lost_item.php?user_id=${userId}&t=${Date.now()}`
        );

        // console.log("API response:", response.data);

        if (response.data.success && Array.isArray(response.data.data)) {
          setProducts(response.data.data);
          //console.log("Lost Data : ", response.data.data);

          const ids = response.data.data.map((p) => p.product_id); // <-- data.data
          fetchBidCounts(ids);
        } else {
          // console.error("Unexpected API structure");
          setProducts([]);
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // console.log(products);

  // Item Get Relist Function

  const relistuserdata = async () => {
    setLoading(true); // ✅ Ensure loading starts

    try {
      const response = await axios.get(
        `${BASE_URL}/get_relist_user.php?t=${Date.now()}`
      );

      // console.log("Relist User", response.data);

      if (response.data.success) {
        setrelistuser(response.data);
      } else {
        setrelistuser([]);
      }
    } catch (error) {
      console.error("❌ Failed to fetch relist user", error);
      setrelistuser([]);
    } finally {
      setLoading(false); // ✅ Always stop loading
    }
  };

  useEffect(() => {
    relistuserdata();
  }, []);

  const relist = async (product_id: number, product_user_id: number) => {
    const response = {
      product_id: product_id,
      product_user_id: product_user_id,
      user_id: login_user_id,
    };

    console.log("Sending data:", response);

    try {
      const res = await axios.post(`${BASE_URL}/relist_request.php`, response, {
        headers: { "Content-Type": "application/json" },
      });

      // console.log(res);

      if (res.data.success) {
        toast.success("Request Sended Successfully!");
        relistuserdata();
      } else {
        // setToastMessage(res.data.message);
        toast.success("Try again letter!");
        relistuserdata();
      }

      // setShowToast(true);
      // setTimeout(() => setShowToast(false), 3000); // Hide after 3 seconds
    } catch (error) {
      console.error(error);
      //  setToastMessage("Server error. Try again.");
      toast.success("Server error. Try again.");
      //setShowToast(true);
      //  setTimeout(() => setShowToast(false), 3000);
    }
  };
  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME </p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span>/</span>

                <p>LOST</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 ">
              <div className="col-12">
                <h2>
                  {loading ? (
                    <b>Loading...</b>
                  ) : (
                    <b>Lost {products.length} Items</b>
                  )}
                </h2>
              </div>
              <div
                className="setting-info"
                style={{ background: "transparent" }}
              >
                <div className="row g-4">
                  {loading ? (
                    <div
                      className="loading-overlay"
                      style={{
                        height: "550px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="dot-spinner">
                        {[...Array(8)].map((_, i) => (
                          <div key={i} className="dot-spinner__dot"></div>
                        ))}
                      </div>
                    </div>
                  ) : products.length === 0 ? (
                    <>
                      <img
                        src={`${BASE_URL}/uploads/logo/data_not_found.png`}
                        alt="No Data Found"
                        style={{
                          width: "100%",
                          height: "450px",
                          objectFit: "contain",
                          mixBlendMode: " darken",
                        }}
                      />
                    </>
                  ) : (
                    products.map((product) => (
                      <div
                        key={product.id}
                        className="col-xl-4 col-lg-4 col-md-6 p-0 wow animate fadeInDown"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <div className="auction-card">
                          <div className="auction-card-img-wrap">
                            <Link
                              to={`/detail/${product.product_id}`}
                              className="card-img"
                            >
                              <img
                                src={
                                  product.photo
                                    ? `${BASE_URL}/${product.photo
                                        .split(",")[0]
                                        .trim()}`
                                    : `${BASE_URL}/uploads/logo/icon.png`
                                }
                                alt={product.photo || "Product Image"}
                              />
                            </Link>
                          </div>
                          <div className="auction-card-content">
                            <p style={{ fontSize: "12px" }}>
                              {formatDate(product.closing_time)}
                            </p>
                            <h6>
                              <Link to={`/detail/${product.product_id}`}>
                                {product.product_title}
                              </Link>
                            </h6>
                            <div className="details_buyer">
                              <h6>Item Id</h6> <p>#{product.product_id}</p>
                            </div>
                            {product.buy_now ? (
                              <div className="details_buyer">
                                <h6>Buy Price</h6>{" "}
                                <p
                                  style={{
                                    color: "#ebc32f",
                                    fontWeight: "800",
                                  }}
                                >
                                  {product.buy_now} SAR
                                </p>
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="details_buyer">
                              <h6>Top Bid</h6>{" "}
                              <p
                                style={{
                                  color: "#ebc32f",
                                  fontWeight: "800",
                                }}
                              >
                                ${product.current_price || product.buy_now}
                              </p>
                            </div>
                            <div className="details_buyer">
                              <h6>Bidders</h6>
                              <p style={{ fontWeight: "800" }}>
                                {BidCount[product.product_id]}
                              </p>
                            </div>

                            <div
                              className="relise"
                              style={{ width: "100%", textAlign: "center" }}
                            >
                              {product?.winner_id && product.winner_id != 0 ? (
                                <p
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                    margin: "0",
                                    color: "red",
                                  }}
                                >
                                  Sold
                                </p>
                              ) : relistuser?.data?.some(
                                  (entry) =>
                                    String(entry.user_id) ===
                                      String(login_user_id) &&
                                    String(entry.product_id) ===
                                      String(product.product_id)
                                ) ? (
                                <p
                                  style={{
                                    color: "green",
                                    fontWeight: "bold",
                                    margin: "0",
                                  }}
                                >
                                  You applied for relist
                                </p>
                              ) : (
                                <button
                                  onClick={() =>
                                    relist(product.product_id, product.user_id)
                                  }
                                  style={{
                                    background: "transparent",
                                    border: "1px solid #ffffffff",
                                    padding: "5px 10px",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                >
                                  Please Relist item again
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Fotter />
    </>
  );
}
